import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ProductRelatedItemComponent } from './product-related-item/product-related-item.component'
import { FlexLayoutModule } from '@angular/flex-layout'
import { MatCardModule } from '@angular/material/card'
import { TranslateModule } from '@ngx-translate/core'
import { PipeModule } from '../../pipes/pipe.module'
import { RouterModule } from '@angular/router'

@NgModule({
  declarations: [ProductRelatedItemComponent],
  imports: [
    CommonModule,
    FlexLayoutModule,
    PipeModule,
    MatCardModule,
    RouterModule,
    TranslateModule.forChild(),
  ],
  exports: [ProductRelatedItemComponent],
})
export class RecommendModule {}
